import { LanguageType } from '@/custom-types';
import { useUserLanguage } from '@/customHooks';
import { RentChargeStatusOption } from '@/graphql/generated';
import styled from 'styled-components';

type RentChargeStatusOptionPillProps = {
  option: RentChargeStatusOption
}

const PillContainer = styled.div<{ $color: string, $backgroundColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: bold;
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

const optionMapping = (option: RentChargeStatusOption, language: LanguageType) => {
  const notReceivedStyle = {
    color: {
      font: '#FF971D',
      background: '#FF971D21'
    }
  };

  const overdueStyle = {
    color: {
      font: '#ff7878',
      background: '#ffd7d7'
    }
  };

  const pendingStyle = {
    color: {
      font: '#FF971D',
      background: '#FF971D21'
    }
  };
  const receivedStyle = {
    color: {
      font: '#4a9462',
      background: '#d2f3dc'
    }
  };

  const mapping = {
    en: {
      [RentChargeStatusOption.NotReceived]: { text: 'Not Received', ...notReceivedStyle},
      [RentChargeStatusOption.Pending]: { text: 'Pending', ...pendingStyle },
      [RentChargeStatusOption.Received]: { text: 'Received', ...receivedStyle },
      [RentChargeStatusOption.Overdue]: { text: 'Overdue', ...overdueStyle}
    },
    es: {
      [RentChargeStatusOption.NotReceived]: { text: 'No recibido', ...notReceivedStyle },
      [RentChargeStatusOption.Pending]: { text: 'Pendiente', ...pendingStyle },
      [RentChargeStatusOption.Received]: { text: 'Recibido', ...receivedStyle },
      [RentChargeStatusOption.Overdue]: { text: 'Vencido', ...overdueStyle}
    },
  };

  return mapping[language][option];
};

export const RentChargeStatusOptionPill = ({ option }: RentChargeStatusOptionPillProps) => {
  const userLanguage = useUserLanguage()

  const optionMapped = optionMapping(option, userLanguage)
  return (
    <PillContainer $color={optionMapped.color.font} $backgroundColor={optionMapped.color.background}>
      {optionMapped.text}
    </PillContainer>
  );
}

